import axios from './axios'

function service(endpoint) {

    function createContact(id) {
        return axios.post(`${endpoint}/${id}/contact`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        createContact
    }
}

export default service
